<template>
  <div>
    <a-spin :spinning="loading">
      <a-tabs
        default-active-key="1"
        :tab-position="mode"
        :style="{ height: '800px' }"
        @change="tabChanged"
      >
        <a-tab-pane
          v-for="provisioning in allProvisionings"
          :key="provisioning.id"
          :tab="provisioning.name"
        >
          <h5>Edit message</h5>
          <div style="width: 50%">
            <a-input class="item" v-model="title" placeholder="Email subject" />
            <a-input class="item" v-model="bcc" placeholder="Email BCC" />

            <a-textarea
              class="item"
              v-model="body"
              placeholder="Email body"
              auto-size
              style="min-height: 200px"
            />
            <a-button
              @click="onSubmit"
              class="btn btn-success px-5 float-right"
              v-show="allProvisionings.length > 0"
            >
              Save
            </a-button>
          </div>
        </a-tab-pane>
      </a-tabs>
    </a-spin>
  </div>
</template>

<script>
import { ProvisioningService } from '@/services/api'

export default {
  props: {},
  data: function () {
    return {
      loading: true,
      mode: 'left',
      allProvisionings: [],
      title: null,
      body: null,
      bcc: null,
      activeTab: null,
    }
  },
  methods: {
    tabChanged(val) {
      this.activeTab = val
      this.title = this.allProvisionings[val - 1].title
      this.body = this.allProvisionings[val - 1].body
      this.bcc = this.allProvisionings[val - 1].bcc
    },
    onSubmit() {
      this.loading = true
      var data = {
        title: this.title,
        body: this.body,
        bcc: this.bcc,
      }

      this.title = null
      this.body = null
      this.bcc = null
      ProvisioningService.update(
        this.allProvisionings[this.activeTab - 1].id,
        data
      ).then((response) => {
        this.getData()
      })
    },
    getData() {
      ProvisioningService.get().then((response) => {
        this.allProvisionings = response.data.data
        if (this.activeTab === null) {
          this.activeTab = 1
        }

        this.title = this.allProvisionings[this.activeTab - 1].title
        this.body = this.allProvisionings[this.activeTab - 1].body
        this.bcc = this.allProvisionings[this.activeTab - 1].bcc

        this.loading = false
      })
    },
  },
  watch: {},
  computed: {
    // a computed getter
  },
  mounted() {
    this.getData()
  },
}
</script>

<style scoped>
.item {
  margin-bottom: 10px;
}
</style>
